import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray} from '@angular/forms';

@Component({
    selector: 'app-quota-modal',
    templateUrl: './quota-modal.component.html',
    styleUrls: ['./quota-modal.component.scss'],
    standalone: false
})
export class QuotaModalComponent implements OnInit, OnChanges {

    @Input()
    aampQuotas: any[];

    @Input()
    entityName: string;

    @Input()
    userNotification?: boolean;

    form: UntypedFormGroup;

    constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder) {
        this.form = this.fb.group({
            quotas: this.fb.array([])
        });
    }

    ngOnInit() {
        if (!this.aampQuotas || this.aampQuotas.length === 0) {
            return;
        }

        for (const item of this.aampQuotas) {
            this.quotas.push(this.createMaxQuotaFormControl(item));
        }
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    get quotas() {
        return this.form.get('quotas') as UntypedFormArray;
    }

    isInvalid(groupControl) {
        return groupControl.controls.maxQuota.dirty && (
            groupControl.hasError('required', 'maxQuota') ||
            groupControl.hasError('pattern', 'maxQuota')
        );
    }

    createMaxQuotaFormControl(quota) {
        return this.fb.group({
            maxQuota: [quota.maxQuota, [Validators.required, Validators.pattern('[0-9]*')]],
            productName: quota.productName,
            rowKey: quota.rowKey,
            entityId: quota.entityId
        });
    }

    onUpdateQuotas() {
        if (this.form.valid) {
            this.activeModal.close(this.convertQuotasToNumbers(this.form.value.quotas));
        }
    }

    public convertQuotasToNumbers(quotas): any[] {
        for (const item of quotas) {
            item.maxQuota = +(item.maxQuota);
        }
        return quotas;
    }

}
